exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay-block[data-v-a0ed7168] {\n  width: 100%;\n  height: 100%;\n  margin: 105px auto auto;\n  position: fixed;\n  display: none;\n  background-color: transparent;\n  z-index: 3;\n  -webkit-transition: .2s;\n  -o-transition: .2s;\n  transition: .2s;\n}\n.overlay-block.is-created[data-v-a0ed7168] {\n    display: -ms-flexbox;\n    display: flex;\n}\n.overlay-block.is-active[data-v-a0ed7168] {\n    background-color: rgba(0, 0, 0, 0.4);\n}\n", ""]);

// exports
